import { render, staticRenderFns } from "./PaymentSettingsStep.vue?vue&type=template&id=b31ee066&scoped=true"
import script from "./PaymentSettingsStep.vue?vue&type=script&lang=js"
export * from "./PaymentSettingsStep.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettingsStep.vue?vue&type=style&index=0&id=b31ee066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ee066",
  null
  
)

export default component.exports